export const T = {
  en_GB: {
    oneTimeCosts: "One-time costs",
    withdrawalCosts: "Withdrawal costs",
    depositCosts: "Deposit costs",
    currencyCosts: "Currency costs",
    totalOneTimeCosts: "Total one-time costs",
  },
  nb_NO: {
    oneTimeCosts: "Engangskostnader",
    withdrawalCosts: "Uttakskostnader",
    depositCosts: "Innskuddskostnader",
    currencyCosts: "Valutakostnader",
    totalOneTimeCosts: "Totale engangskostnader",
  },
} as const;
